<div class="bg-first">
  <h3 class="text-center top-title">Descoperă rețeaua <br /> Plugpoint</h3>
  <div class="row">
    <div class="col-xl-4 container-padding-left">
      <div class="col-xl-12 mb-4">
        <h6 class="mb-3 h-padding-bottom"> Creează-ți cont în aplicație
        </h6>
        <p>
          În contul tău găsești toate stațiile tale favorite, istoricul încărcărilor și facturile electronice. Iți
          selectezi ușor modalitatea de plată și ai posibilitatea de a deconta cheltuielile direct cu angajatorul tău.
        </p>
      </div>
      <div class="col-xl-12 mb-4">
        <h6 class="mb-3 h-padding-bottom">
          Verifică disponibilitatea stațiilor de lângă tine
         
        </h6>
        <p>
          Doar la un ”tap” distanță, poți verifica care este cea mai apropiată stație disponibilă ca să nu ai surpriza
          de a ajunge la o stație deja
          ocupată. Platforma noastră comunică în timp real ca tu să ai
          informațiile la îndemână. #CheckInAutomat
        </p>
      </div>
    </div>
    <div class="col-xl-4 phone-container">
      <div class="col-xl-12 text-center phone-container"><img class="phone-img" src="./assets/img/iphone6.png" alt="">
      </div>
    </div>
    <div class="col-xl-4 container-padding-smallscreen">
      <div class="col-xl-12 mb-4">
        <h6 class="mb-3 h-padding-bottom">
          <!-- <a href="#" class="text-color">
            <fa-icon [icon]="faLink"></fa-icon> Rezervă stația în drum spre ea
          </a> -->Rezervă stația în drum spre ea
        </h6>
        <p>
          Ai posibilitatea de a rezerva stația de încărcare cu 15 minute înainte
          să ajungi în locație. În acest interval de timp, stația pornește doar la
          comanda ta. Așa ne asigurăm că nu pierzi timpul pe drum, cu
          bateria aproape descărcată. #SuntPeDrum
        </p>
      </div>
      <div class="col-xl-12 mb-4">
        <h6 class="mb-3 h-padding-bottom">
          <!-- <a href="#" class="text-color">
            <fa-icon [icon]="faLink"></fa-icon> Controlează din aplicație
          </a> -->Controlează din aplicație
        </h6>
        <p>
          Odată ce ai dat start la încărcare, începe contorizarea în timp real.
          Poți verifica, din cafeneaua ta preferată, de cât timp ești conectat,
          câți kWh ai încărcat și cât ai de achitat. Dacă nu vrei să stai cu ochii
          în telefon, te anunțăm noi când bateria este ”full”.
        </p>
      </div>
    </div>
  </div>

  <!-- <div class="row"> -->
  <section class="download bg-primary text-center" id="download">
    <div class="container">
      <div class="row">
        <div class="col-md-8 mx-auto">
          <h3 class="section-heading">Descarcă aplicația <br /> Plugpoint</h3>
          <!-- <p>Download now to get started!</p> -->
          <div class="badges">
            <a class="badge-link" target="_blank"
              href="https://play.google.com/store/apps/details?id=com.gobreazy.app"><img
                src="./assets/img/google-play-badge.svg" alt=""></a>
            <a class="badge-link" target="_blank" href="https://apps.apple.com/us/app/plugpoint/id1456784558?ls=1"><img
                src="./assets/img/app-store-badge.svg" alt=""></a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- </div> -->
  <div class="next-steps bg-first">
    <h3 class="text-center bottom-title">Creează propria rețea de încărcare</h3>
    <div class="row">
      <div class="col-xl-4 laptop-container">
        <div class="col-xl-12 text-center laptop-container"><img class="laptop-img" src="./assets/img/laptop_dashboard.png" alt="">
        </div>
      </div>
      <div class="col-xl-4 container-padding-smallscreen">
        <div class="col-xl-12 mb-4">
          <h6 class="mb-3 h-padding-bottom">
            <!-- <a href="#" class="text-color">
              <fa-icon [icon]="faLink"></fa-icon> Noi ne ocupăm de ”logistică”, iar tu de creșterea afacerii
            </a> -->Noi ne ocupăm de ”logistică”, iar tu de creșterea afacerii
          </h6>
          <p>
            Stațiile de încărcare prezintă o nouă oportunitate de a iți dezvolta
            afacerea. Oferim o soluție autonomă ca tu să te concentrezi pe ce
            este important. Noi ne ocupăm de încărcările clienților electrici, iar tu
            ai vizibilitate pe tot ce se întamplă în rețeaua ta.
          </p>
        </div>
        <div class="col-xl-12 mb-4">
          <h6 class="mb-3  h-padding-bottom">
            <!-- <a href="#" class="text-color">
              <fa-icon [icon]="faLink"></fa-icon> Tarifează încărcarile automat
            </a> -->Tarifează încărcarile automat
          </h6>
          <p>
            Fiecare încărcare se tranzacționează automat, se emit facturi
            electronice pentru clienții tăi, iar pentru contabilitate procesul este
            simplu și clar. Clienții sunt mulțumiți, costurile cu energia sunt
            acoperite și veniturile se încasează lunar.
          </p>
        </div>
      </div>
      <div class="col-xl-4 container-padding-smallscreen">
        <div class="col-xl-12 mb-4">
          <h6 class="mb-3 h-padding-bottom">
            <!-- <a href="#" class="text-color">
              <fa-icon [icon]="faLink"></fa-icon> Ai control de la distanță, în timp real
            </a> --> Ai control de la distanță, în timp real
          </h6>
          <p>
            Tu decizi prețurile pentru serviciile de încărcare, individual pentru
            fiecare locație. Se pot analiza statistici detaliate despre încărcări,
            costuri, venituri și comportament de utilizare. Ai controlul și ești
            mereu informat astfel încât să iei cele mai bune decizii.
          </p>
        </div>
        <div class="col-xl-12 mb-4">
          <h6 class="mb-3 h-padding-bottom">
            <!-- <a href="#" class="text-color">
              <fa-icon [icon]="faLink"></fa-icon> Soluție inclusă în abonamentele business
            </a> -->Soluție inclusă în abonamentele business
          </h6>
          <p>
            Fie că ai o stație publică sau mai multe, ai acces în platforma de
            administrare cu un simplu cont business. Contactează-ne ca să îți
            trimitem toate informațiile necesare pentru a face parte din rețeaua
            de încărcare Plugpoint.
          </p>
        </div>
      </div>
    </div>

    <!-- <div class="row"> -->
    <section class="download bg-primary-bottom text-center" id="download">
      <div class="container">
        <div class="row">
          <div class="col-md-10 mx-auto">
            <h3 class="section-heading"><span class="white-color">Intră în rețeaua</span> <br />
              <h3 class="section-heading">Plugpoint</h3>
            </h3>
            <!-- <p> All you need for your infrastructure</p> -->
            <div class="badges">
              <a href="https://www.plugpoint.ro/contact/" target="_blank"><button nbButton status="primary"
                  shape="round" size="large" class="btn btn-margin">
                  <nb-icon icon="email-outline"></nb-icon>Contact
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- </div> -->